import React, { useEffect, useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { BookOpen, CheckCircle2, Clock } from 'lucide-react';
import { centerToast } from './CenterToast';
import { getMemberIdentity } from '../lib/session';
import { getUlum, enrolUlum } from '../lib/vms';

const TERM = 'Term 1';

function Chips({ options, sel, setSel }) {
  const toggle = (id) => setSel(sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id]);
  return (
    <div className="flex flex-wrap gap-1.5">
      {options.map((o) => (
        <button key={o.id} type="button" onClick={() => toggle(o.id)}
          className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors ${sel.includes(o.id) ? 'bg-primary text-primary-foreground border-primary' : 'bg-card text-muted-foreground border-border'}`}>
          {o.name || o.label}
        </button>
      ))}
    </div>
  );
}

export default function UlumEnroll() {
  const [data, setData] = useState(undefined); // undefined=loading, null=unavailable
  const [hubs, setHubs] = useState([]); const [slots, setSlots] = useState([]);
  const [editing, setEditing] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const load = () => getUlum(TERM).then((d) => {
    setData(d);
    if (d) { setHubs(d.enrollment?.hubPrefs || []); setSlots(d.enrollment?.slotPrefs || []); }
  }).catch(() => setData(null));
  useEffect(() => { load(); }, []);

  if (data === undefined || data === null) return null;      // not signed in / VMS down
  if (!data.open) return null;                                // enrolment not set up yet

  const submit = async () => {
    setSubmitting(true);
    const id = getMemberIdentity();
    const r = await enrolUlum({ term: TERM, name: id?.fullName, hubPrefs: hubs, slotPrefs: slots, autoReassign: true });
    setSubmitting(false);
    if (r.ok) { centerToast(r.message || 'Registered', '📖'); setEditing(false); load(); }
    else centerToast(r.error, '⚠️');
  };

  const enr = data.enrollment;
  return (
    <div className="px-4 pt-4">
      <Card className="border-l-4 border-l-primary">
        <CardContent className="p-4">
          <div className="flex items-center gap-2 mb-1">
            <BookOpen className="h-5 w-5 text-primary" />
            <h3 className="font-semibold text-base">Ulum Ihsan — {TERM}</h3>
          </div>

          {enr?.assignedClass ? (
            <div className="mt-2 text-sm">
              <p className="inline-flex items-center gap-1.5 text-primary font-semibold"><CheckCircle2 className="h-4 w-4" /> You're placed</p>
              <p className="text-muted-foreground mt-1">{enr.assignedClass.hub} · {enr.assignedClass.slot}{enr.assignedClass.asatizah ? ` · with ${enr.assignedClass.asatizah}` : ''}</p>
            </div>
          ) : enr && !editing ? (
            <div className="mt-2 text-sm">
              <p className="inline-flex items-center gap-1.5 text-amber-600 font-medium"><Clock className="h-4 w-4" /> Registered — awaiting placement</p>
              <p className="text-muted-foreground mt-1">{enr.hubPrefs.length} hubs · {enr.slotPrefs.length} slots chosen</p>
              <Button variant="outline" size="sm" className="mt-3 h-8" onClick={() => setEditing(true)}>Edit choices</Button>
            </div>
          ) : (
            <div className="mt-2">
              <p className="text-sm text-muted-foreground mb-3">Register for weekly religious classes. Pick at least <b>2 hubs</b> and <b>2 time slots</b> — we'll place you in one that forms.</p>
              <p className="text-xs font-semibold text-muted-foreground mb-1.5">Hubs</p>
              <Chips options={data.hubs} sel={hubs} setSel={setHubs} />
              <p className="text-xs font-semibold text-muted-foreground mt-3 mb-1.5">Time slots</p>
              <Chips options={data.slots} sel={slots} setSel={setSlots} />
              <Button size="sm" className="mt-4 h-9" disabled={submitting || hubs.length < 2 || slots.length < 2} onClick={submit}>
                {submitting ? 'Registering…' : enr ? 'Update registration' : 'Register'}
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
